export enum FileType {
  EXCEL = 'excel',
  XLSX = 'xlsx',
  DOCX = 'docx',
  KMZ = 'kmz',
  SHAPE = 'shape',
  PDF = 'pdf',
  CSV = 'csv',

  // Media
  APNG = 'apng',
  GIF = 'gif',
  MP4 = 'mp4',
  TIFF = 'tiff',
  JPG = 'jpg',
  SVG = 'svg'
}

export namespace FileType {
  export function getLabel(fileType: FileType) {
    return fileType.toUpperCase()
  }

  export const getMimeType = (fileType: FileType): string => {
    switch (fileType) {
      case FileType.EXCEL:
      case FileType.XLSX:
        return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      case FileType.DOCX:
        return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
      case FileType.CSV:
        return 'text/csv'
      case FileType.PDF:
        return 'application/pdf'
      case FileType.KMZ:
        return 'application/vnd.google-earth.kmz'
      case FileType.SHAPE:
        return 'application/x-zip'
      case FileType.APNG:
        return 'image/apng'
      case FileType.GIF:
        return 'image/gif'
      case FileType.MP4:
        return 'video/mp4'
      case FileType.TIFF:
        return 'image/tiff'
      case FileType.JPG:
        return 'image/jpeg'
      case FileType.SVG:
        return 'image/svg'
      default:
        console.error('Unknown file type', fileType)
        throw new Error('Unknown file type', fileType)
    }
  }

  export const getExtension = (fileType: FileType): string => {
    switch (fileType) {
      case FileType.KMZ:
        return 'kmz'
      case FileType.SHAPE:
        return 'zip'
      case FileType.PDF:
        return 'pdf'
      case FileType.CSV:
        return 'csv'
      case FileType.XLSX:
        return 'xlsx'
      case FileType.DOCX:
        return 'docx'
      case FileType.APNG:
        return 'apng'
      case FileType.GIF:
        return 'gif'
      case FileType.MP4:
        return 'mp4'
      default:
        return ''
    }
  }

  export function getIcon(type: FileType) {
    switch (type) {
      case FileType.TIFF:
        return 'mi mi-download-tiff'
      case FileType.APNG:
        return 'mi mi-download-apng'
      case FileType.GIF:
        return 'mi mi-download-gif'
      case FileType.MP4:
        return 'mi mi-download-mp4'
      case FileType.JPG:
        return 'pi-image'
      case FileType.PDF:
        return 'pi pi-file-pdf'
      default:
        return 'pi-image'
    }
  }
}
